import React from 'react';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import Fade from '@material-ui/core/Fade';
import { connect } from "react-redux";
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

function FadeMenu(props) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    //------------For list and chckbox
  const [checked, setChecked] = React.useState([0]);
  const [selected_state, Set_selected_state] = React.useState(props.checked);
  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };
  var handleChange=(event)=>{
    Set_selected_state(event.target.value)
    props.Set_checked(event.target.value)
  }
  return (
        <div style={{paddingTop:0,height:36}}>
            <Button style={{borderRadius:0,fontWeight: "bold",fontSize:16}} aria-controls="fade-menu" aria-haspopup="true" onClick={handleClick}>{props.view=="Default"?"Filter By":"Quartile By"}<ArrowDropDownIcon></ArrowDropDownIcon>
      </Button>
            <Menu
                id="fade-menu"
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={handleClose}
                TransitionComponent={Fade}
            >
                <div className="radioContainer" style={{padding:"0px 15px"}}>
                <RadioGroup aria-label="gender" name="gender1" value={selected_state} 
                onChange={(event)=>handleChange(event)}>
                    {[['sentiment',"FlairSentimentScore"],['subjectivity',"SubjectivityScore"]].map((value) => {
                        return <FormControlLabel value={value[1]} control={<Radio />} label={value[0]} />
                    })}
                </RadioGroup>
                </div>
            </Menu>
        </div>
    );
}
const maptstateToprop = (state) => {
    return {
        checked:state.checked,
    }
}
const mapdispatchToprop = (dispatch) => {
    return {
        Set_checked: (val) => dispatch({ type: "checked", value: val }),       
    }
}
export default connect(maptstateToprop, mapdispatchToprop)(FadeMenu);
//https://material-ui.com/components/menus/
